import type { ApiError } from "../../shared/contracts";

export class ApiClient {
  async request<T>(path: string, options: RequestInit = {}): Promise<T> {
    const response = await fetch(path, {
      credentials: "same-origin",
      cache: "no-store",
      ...options,
      headers: {
        ...(options.body ? { "Content-Type": "application/json" } : {}),
        ...Object.fromEntries(new Headers(options.headers)),
      },
    });
    const data: unknown = await response.json().catch(() => ({}));
    if (!response.ok) {
      const error = data as Partial<ApiError>;
      throw new ApiRequestError(error.error ?? "Request failed.", response.status);
    }
    return data as T;
  }
}

export class ApiRequestError extends Error {
  constructor(message: string, readonly status: number) {
    super(message);
    this.name = "ApiRequestError";
  }
}

export function errorMessage(error: unknown): string {
  return error instanceof Error ? error.message : "Something went wrong. Please try again.";
}
